import { IAppService, IStateConfig, IFxpAppContext, IServiceEndPoints, IRouteInfo, IPartnerBundle, ISharedComponents, ISharedComponentConfig, ComponentFramework } from '@fxp/fxpservices';
import * as React from 'react';
import { appSettings } from './environments/common/appsettingsGenerator';
import { PartnerAppRegistrationService } from '@fxp/fxpservices';

export class CsudaApplication_routes implements IAppService {

  getSharedComponentsInfo(): ISharedComponents {
    const weeklyDigestForAccountsViewComponent: ISharedComponentConfig = {
      componentName: "csuda-weeklydigestforaccountsview", // Unique name of component in format <appname>.<componentname> in lower case.
      exposeAsExternalComponents: false, // Setting it to true will make this component as external component. Keep it false if you want to consume only in context of FxP.
      componentFramework: ComponentFramework.React,
      generatedBundle: 'csuda-bundle' // Link to generated bundle
    }

    const sharedComponentsInProject: ISharedComponents =  {
      appName: 'csuda', // Name of the application. Use the same name what you have used in main.ts file with registerPartnerApp method.
      components: [weeklyDigestForAccountsViewComponent], // List of ISharedComponentConfig. Add all the ISharedComponentConfig objects here.
      disableSharing: false, // Turing it off will disable the sharing and your partners will not be able to consume the components.
      sharedBundles: []
    }
    return sharedComponentsInProject;
  }

  getRoutes(fxpContext: IFxpAppContext): IRouteInfo {
    const weeklyDigestForAccountsViewComponent: IStateConfig = {
      name: 'weeklydigest',
      url: '/weeklydigest',
      componentFramework: ComponentFramework.React,
      data: {
        headerName: 'Weekly Digest',
        breadcrumbText: 'Weekly Digest',
        pageTitle: 'Weekly Digest'
      }
    }
    const routeInfo: IRouteInfo = {
      applicationName: 'csuda',
      sharedBundles: [],
      routes: [weeklyDigestForAccountsViewComponent]
    }

    return routeInfo;
  }

  getServiceEndPoints(): Array<IServiceEndPoints> {
    return appSettings().serviceEndPoints;
  }

  getBundles(): IPartnerBundle[] {
    const baseUrl = appSettings().cdnBaseUrl;
    const bundle: IPartnerBundle = {
      name: 'csuda-bundle',
      files: [
        `${baseUrl}/vendor.bundle.js`,
        `${baseUrl}/styles.bundle.js`,
        `${baseUrl}/main.bundle.js`,
      ],
      sequentialLoading: true,
    };

    return [bundle];
  }

  /**
   * Dynamically generates bundles based on the current script URL.
   * This prevents the CDN URL from being overwritten when this component
   * is consumed elsewhere via routes.bundle.js
   * @returns Array of IPartnerBundle with dynamically resolved base URL
   */
  getGeneratedBundles(): IPartnerBundle[] {
    let baseUrl = '';
    
    // Get the current script URL
    const currentScript = document.currentScript as HTMLScriptElement;
    let currentScriptUrl = currentScript?.src || '';
    
    if (currentScriptUrl.indexOf('exclude.inline.bundle') > 0) {
      // Fallback: extract URL from error stack trace
      const stackUrls = new Error().stack?.match(/(https?:\/\/[^ ]*)/g) || [];
      const filteredUrls = stackUrls.filter((item) => {
        return item.indexOf('localhost:5000') === -1;
      });
      
      if (filteredUrls.length > 0) {
        baseUrl = filteredUrls[0].toLowerCase();
        baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'));
      }
    } else if (currentScriptUrl) {
      baseUrl = currentScriptUrl.substring(0, currentScriptUrl.lastIndexOf('/'));
    }
    
    // Remove trailing slash if present
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl.substring(0, baseUrl.length - 1);
    }
    
    // Fallback to appSettings if baseUrl couldn't be determined
    if (!baseUrl) {
      baseUrl = appSettings().cdnBaseUrl;
    }

    return [{
      name: 'csuda-bundle',
      files: [
        `${baseUrl}/vendor.bundle.js`,
        `${baseUrl}/styles.bundle.js`,
        `${baseUrl}/main.bundle.js`
      ],
      sequentialLoading: true
    }];
  }
}

PartnerAppRegistrationService.registerLazyLoadedApp(CsudaApplication_routes);
